import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Newspaper, ArrowRight, Calendar } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NewsletterSection = () => {
  const [newsletters, setNewsletters] = useState([]);

  useEffect(() => {
    axios.get(`${API}/newsletter-archive`).then(r => {
      setNewsletters((r.data || []).slice(0, 3));
    }).catch(() => {});
  }, []);

  if (newsletters.length === 0) return null;

  return (
    <section className="py-24 bg-white" data-testid="newsletter-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
          <div className="flex items-end justify-between mb-12">
            <div>
              <span className="text-lab-accent text-sm font-semibold tracking-widest uppercase">Newsletter</span>
              <h2 className="font-playfair text-2xl lg:text-3xl font-semibold text-lab-primary mt-3">
                Aus unserem Newsletter
              </h2>
              <p className="text-lab-text-muted mt-2 max-w-xl">Praxisnahe Insights zu KI, Digitalisierung und Prozessoptimierung für Schweizer KMU.</p>
            </div>
            <Link to="/newsletter" className="hidden md:flex items-center gap-2 text-lab-accent hover:text-lab-primary transition-colors text-sm font-medium" data-testid="newsletter-view-all">
              Alle Ausgaben <ArrowRight className="w-4 h-4" />
            </Link>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {newsletters.map((nl, i) => (
              <motion.div key={nl.id} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.1 }}>
                <Link to={`/newsletter/${nl.id}`} className="block p-6 border border-lab-border bg-lab-bg-light hover:border-lab-accent transition-all group h-full" data-testid={`newsletter-preview-${nl.id}`}>
                  <div className="flex items-center gap-2 text-xs text-lab-text-muted mb-3">
                    <Calendar className="w-3 h-3" />
                    <span>{new Date(nl.published_at).toLocaleDateString("de-CH", { day: "numeric", month: "long", year: "numeric" })}</span>
                  </div>
                  <div className="flex items-center gap-2 mb-3">
                    <Newspaper className="w-4 h-4 text-lab-accent" />
                    <span className="text-xs bg-white px-2 py-0.5 border border-lab-border text-lab-text-muted">{nl.category}</span>
                  </div>
                  <h3 className="font-playfair text-lg font-semibold text-lab-primary group-hover:text-lab-accent transition-colors mb-2">{nl.title}</h3>
                  {nl.summary && <p className="text-lab-text-muted text-sm line-clamp-3">{nl.summary}</p>}
                  <span className="text-lab-accent text-sm mt-4 inline-block font-medium">Lesen →</span>
                </Link>
              </motion.div>
            ))}
          </div>

          <div className="mt-8 text-center md:hidden">
            <Link to="/newsletter" className="inline-flex items-center gap-2 text-lab-accent hover:text-lab-primary text-sm font-medium">
              Alle Ausgaben ansehen <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default NewsletterSection;
